<aw-section
  testIdAffix="appearance-highlighted-actions"
  [isCollapsible]="true"
  [forceCollapse]="forceCollapse()"
  [withoutContentPadding]="true">
  <aw-section-header>
    <span class="text-standard-text-primary text-2xl font-semibold">
      {{ cmsTextProvider.appearanceText.ctaHeader }}
    </span>
  </aw-section-header>

  <div
    class="grid grid-cols-1 gap-6 pt-7 xl:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <h3 class="text-standard-text-primary ml-8 text-xl font-semibold">
      {{ cmsTextProvider.appearanceText.ctaColours }}
    </h3>

    <div class="min-w-0">
      <p class="text-standard-text-secondary text-m mb-2 leading-5">
        {{ cmsTextProvider.appearanceText.ctaColoursHint }}
      </p>

      <div class="grid grid-cols-1 gap-3 2xl:grid-cols-2">
        <ng-container
          *ngTemplateOutlet="ctaPreviewCard; context: { dark: false }" />
        <ng-container
          *ngTemplateOutlet="ctaPreviewCard; context: { dark: true }" />
      </div>
    </div>
  </div>

  <hr class="my-8" />

  <aw-appearance-font-upload (draftChange)="fontDraftChange.emit($event)" />
</aw-section>

<ng-template #ctaPreviewCard let-dark="dark">
  <article
    class="rounded-md border"
    [ngClass]="
      dark
        ? 'border-neutral-700 bg-[#111111] text-neutral-100'
        : 'border-standard-outline-light text-standard-text-primary bg-white'
    ">
    <div class="flex justify-end px-3 pt-3">
      <span
        class="flex h-8 items-center gap-1.5 rounded-full border px-2.5 text-sm leading-none"
        [ngClass]="
          dark
            ? 'border-neutral-700 bg-neutral-800 text-neutral-300'
            : 'border-standard-outline-light bg-white'
        ">
        <span
          aria-hidden="true"
          class="material-symbols-rounded icon-filled inline-flex size-5 shrink-0 items-center justify-center !text-lg leading-none">
          {{ dark ? 'dark_mode' : 'light_mode' }}
        </span>
        {{
          dark
            ? cmsTextProvider.appearanceText.controlsDarkMode
            : cmsTextProvider.appearanceText.controlsLightMode
        }}
      </span>
    </div>

    <div class="flex flex-col gap-2 p-3">
      <button
        type="button"
        tabindex="-1"
        class="flex h-10 items-center justify-center gap-3 rounded-lg border font-semibold"
        [style.backgroundColor]="fillColor(dark)"
        [style.borderColor]="borderColor(dark)"
        [style.color]="contrastColor(dark)"
        [style.borderRadius.rem]="
          designForm().controls.buttonBorderRounding.value
        ">
        <span
          aria-hidden="true"
          class="material-symbols-rounded inline-flex size-5 items-center justify-center !text-xl leading-none"
          >add</span
        >
        {{ cmsTextProvider.appearanceText.ctaPrimaryAction }}
      </button>

      <button
        type="button"
        tabindex="-1"
        class="flex h-10 items-center justify-center gap-3 rounded-lg border bg-transparent font-semibold"
        [style.borderColor]="outlineColor(dark)"
        [style.color]="outlineColor(dark)"
        [style.borderRadius.rem]="
          designForm().controls.buttonBorderRounding.value
        ">
        <span
          aria-hidden="true"
          class="material-symbols-rounded inline-flex size-5 items-center justify-center !text-xl leading-none"
          >add</span
        >
        {{ cmsTextProvider.appearanceText.ctaSecondaryAction }}
      </button>
    </div>

    <div
      class="mx-3 border-t"
      [ngClass]="dark ? 'border-neutral-800' : 'border-neutral-200'"></div>

    <div class="flex flex-col gap-3 p-3">
      @for (color of colors; track color.key) {
        <div>
          <div class="relative flex items-center gap-2 text-base">
            <aw-color-picker-list 
              [color]="swatchColor(color.key, dark)"
              (colorChanged)="selectColor(color.key, dark, $event)"></aw-color-picker-list>
            <span>{{ color.label }}</span>
          </div>

          @if (color.description) {
            <p
              class="mt-1 pl-8 text-sm leading-5"
              [ngClass]="dark ? 'text-neutral-400' : 'text-neutral-500'">
              {{ color.description }}
            </p>
          }
        </div>
      }
    </div>
  </article>
</ng-template>
